/**
 * 这个文件是被废弃了吗？找不到引用这个文件的地方
 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { Dialog } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

const getQuery = (key) => {
  const w = location.hash.indexOf('?');
  const query = location.hash.substring(w + 1);

  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == key) {
      return pair[1];
    }
  }

  return null;
};

const Page = (props) => {
  const [dataList, setDataList] = useState([123]);
  const [show, setShow] = useState(false);
  const [wxAppId, setWxAppid] = useState('');
  useEffect(() => {
    const authCode = getQuery('auth_code');
    console.log(authCode);

    RPCFactory.fansManagement
      .updateAuthorizeInfo({
        authorizationCode: authCode,
      })
      .done((data) => {
        if (data.authorizedAccountIds && _.isArray(data.authorizedAccountIds) && data.authorizedAccountIds.length > 0) {
          setDataList(data.authorizedAccountIds);
          setWxAppid(data.wxAppId);
          setShow(true);
        } else {
          location.hash = '/fan/official/offocialAccounts';
        }
      })
      .fail((status, error) => {
        alert(error);
      });
  }, []);

  const handleCancel = () => {
    setShow(false);
    location.hash = '/fan/official/offocialAccounts';
  };

  const handleSubmit = () => {
    RPCFactory.fansManagement
      .confirmAuthorizer(wxAppId, {
        authorizeAccountId: window.pageProps.uid,
      })
      .done(() => {
        location.hash = '/fan/official/offocialAccounts';
      })
      .fail((status, error) => {
        alert(error);
      });
  };

  return (
    <main className="main" id="main">
      <div className="">
        <div className="sec sec-top-tab">
          <div className="datalist-tabs spaui-tabs">
            <div className="spaui-tabs-head">
              <ul className="spaui-tabs-nav">
                <li>
                  <a>公众号授权</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="card card-set-height">
          <div id="datarea">
            <Dialog show={true} type="tip" iconType="loading">
              正在授权公众号
            </Dialog>
          </div>
          <Dialog
            backdrop
            type="normal"
            className="spaui-dialog-confirm-normal modal-bind-fail"
            title={`该公众号已被账户(${dataList.join('、')})授权`}
            iconType="remind"
            show={show}
            onClose={handleCancel}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            style={{ width: '580px' }}
            submitLabel="继续授权"
          >
            <div className="idlist">
              <p className="bd">确认授权后原授权账户将被自动解除绑定，请谨慎操作</p>
            </div>
          </Dialog>
        </div>
      </div>
    </main>
  );
};

export default Page;
